import FutureSelect from "components-new/FutureSelect";
import { FC } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ReactComponent as BackArrow } from "../../../../images/back-arrow.svg";
import styles from "./StepInfo.module.sass";

interface StepInfoProps {
	info: any;
	stepTitle?: string;
	companyName?: string;
	withBackButton?: boolean;
	link?: { to: string; text: string } | undefined;
	children?: any;
	select?: any;
}

const StepInfo: FC<StepInfoProps> = ({
	stepTitle,
	info,
	companyName,
	link,
	withBackButton = true,
	select,
	children,
}) => {
	const navigate = useNavigate();

	const goBack = () => {
		navigate(-1);
	};

	return (
		<div className={styles.stepInfo}>
			{withBackButton && (
				<div onClick={goBack} className={styles.backIcon}>
					<BackArrow />
				</div>
			)}
			<div className={styles.content}>
				<div className={styles.title}>{stepTitle || children}</div>
				<div className={styles.info}>{info}</div>
				{link && (
					<Link to={link.to} className="link">
						{link.text}
					</Link>
				)}
				<div className={styles.companyName}>{companyName}</div>
				{select && (
					<div>
						<FutureSelect
							ref={select.ref}
							onSelect={select.onSelect}
							value={select.value}
							current={select.current}
							options={select.options}
							field={select.field}
							setQuery={select.setQuery}
							query={select.query}
							placeholder={select.placeholder}
							className={select.className}
						/>
					</div>
				)}
			</div>
		</div>
	);
};
export default StepInfo;
